import React, { useEffect, useState } from 'react';
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip } from '@mui/material';
import { tiposCargas, tiposServicos, getLabelEnquadramento } from "../../static";
import { materialTableLocalization } from "../../config";
import MaterialTable from "@material-table/core";
import { useStoreActions, useStoreState } from "easy-peasy";
import api from "../../services/api";
import DialogoAcompanhaOrcamentosFaseOne from './DialogoAcompanhaOrcamentosFaseOne';

export default function ListTomadaPreco({ currProcesso, tipoCarga }) {
    let startLoading = useStoreActions((actions) => actions.nav.startLoading);
    let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
    const [listaOrcamentos, setListaOrcamentos] = React.useState([]);
    const [columns, setColumns] = React.useState([]);
    const tableRef = React.createRef();
    const [reloadTable, setReloadTable] = React.useState(0);
    const [openDlgViewFaseOne, setOpenDlgViewFaseOne] = React.useState(false);
    const [rowDataFaseOne, setRowDataFaseOne] = React.useState([]);
    const [dados, setDados] = React.useState();


    const formatDateToPtBr = (dateString) => {
        if (!dateString) return '';

        // Cria um objeto de data a partir do string
        const date = new Date(dateString);

        // Verifica se a data é válida
        if (isNaN(date.getTime())) return '';

        // Formata a data no padrão pt-BR (dd/mm/yyyy)
        return date.toLocaleDateString('pt-BR').slice(0, 10);
    };

    const loadOrcamentos = async (query) => {
        startLoading();
        try {
          let response;
    
          if (tipoCarga === 'esco' || tiposCargas.some((tec) => tec.id === tipoCarga)) {
            // Busca por tecnologias ou esco
            response = await api.http.get("/orcamentos/processo/tomada/tecnologia", {
              params: {
                page: query.page + 1,
                pageSize: query.pageSize,
                processoId: currProcesso.id,
                tecnologia: tipoCarga,
                estagio: "tomada",
                search: query.search,
                orderBy: query.orderBy ? query.orderBy.field : undefined,
                orderDirection: query.orderDirection ? query.orderDirection : undefined,
              },
            });
          } else if (tiposServicos.some((tec) => tec.id === tipoCarga)) {
            // Busca por serviços
            response = await api.http.get("/orcamentos/processo/tomada/servico", {
              params: {
                page: query.page + 1,
                pageSize: query.pageSize,
                processoId: currProcesso.id,
                servico: tipoCarga,
                estagio: "tomada",
                search: query.search,
                orderBy: query.orderBy ? query.orderBy.field : undefined,
                orderDirection: query.orderDirection ? query.orderDirection : undefined,
              },
            });
          } else {
            console.warn(`Tipo de carga desconhecido: ${getTipoCarga(tipoCarga)}`);
            stopLoading({
              message: "Tipo de carga inválido.",
              severity: "error",
            });
            return { data: [], page: 0, totalCount: 0 };
          }
      
          const getOrcamentos = response.data;
      
          stopLoading();
      
          setListaOrcamentos(getOrcamentos.data); 
      
          return {
            data: getOrcamentos.data,
            page: getOrcamentos.meta.current_page - 1,
            totalCount: getOrcamentos.meta.total,
          };
        } catch (error) {
          stopLoading({
            message: error.toString(),
            severity: "error",
          });
          return { data: [], page: 0, totalCount: 0 };
        }
      };


    const estagios = [
        { cod: "tomada", descricao: 'Tomada de Preço Solicitado' },
        { cod: "tomadaresposta", descricao: 'Tomada de Preço Respondido' },

    ];

    const getDescricaoEstagio = (datafase1) => {

        const cod = datafase1 === null || datafase1 === undefined ? "tomada" : "tomadaresposta";

        const estagio = estagios.find((e) => e.cod === cod);
        return estagio ? estagio.descricao : "Desconhecido";
    };

    const getTipoCarga = (cod) => {
        let nomecarga = tiposCargas.find((e) => e.id === cod);
        if (nomecarga === undefined || nomecarga === null){
          nomecarga = tiposServicos.find((f) => f.id === cod);
        }
        return nomecarga ? nomecarga.label : "Desconhecido";
    };

    React.useEffect(() => {
        setColumns([
            {
                field: "id",
                align: "left",
                title: "Nr. Solicitação"
            },
            {
                field: "tipoCarga",
                align: "left",
                title: "Tipo da Tecnologia/Serviço",
                render: (rowData) => {
                  if (rowData.orcamentoProcessoTipo && rowData.orcamentoProcessoTipo.length > 0) {
                    return (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {rowData.orcamentoProcessoTipo.map((opt) => {
                          const label = opt.tecnologia?.label || opt.servico?.label || "Desconhecido";
                          return <Chip key={opt.id} label={label} size="small" variant="outlined" />;
                        })}
                      </Box>
                    );
                  }
                  return <Chip label={getTipoCarga(rowData.tipoCarga)} size="small" variant="outlined" />;
                },
            },
            {
                field: "enquadramento",
                align: "left",
                title: "Enquadramento",
                render: (rowData) => getLabelEnquadramento(rowData.enquadramento),
            },
            {
                field: "fornecedorNome",
                align: "left",
                title: "Fornecedor",
            },
            {
                field: "enviofase1At",
                align: "left",
                title: "Data solicitação fase 1",
                render: (rowData) => formatDateToPtBr(rowData.enviofase1At),
            },
            {
                field: "finishedAt",
                align: "left",
                title: "Data encerramento",
                render: (rowData) => formatDateToPtBr(rowData.finishedAt),
            },
            {
              field: "estagio",
              align: "center",
              title: "Status",
              render: (rowData) => {
                const cod =
                  rowData.respostafase1At === null || rowData.respostafase1At === undefined
                    ? "tomada"
                    : "tomadaresposta";

                const isRespondido = cod === "tomadaresposta";

                return (
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: isRespondido ? "success.main" : "text.primary" }}
                  >
                    {getDescricaoEstagio(rowData.respostafase1At)}
                  </Typography>
                );
              },
            },

        ]);
    }, []);

    useEffect(() => {
        if (tipoCarga) {
            loadOrcamentos({ page: 0, pageSize: 5 });
        }
    }, [tipoCarga]);

    const onRowClick = async (event, rowData) => {
        startLoading();
        try {
            let getOrcamentos = await api.http.get("/orcamentos/processo/tomada/itens/" + rowData.id);
            setDados(getOrcamentos);

            setRowDataFaseOne(rowData);
            setOpenDlgViewFaseOne(true);
            stopLoading();
        } catch (error) {
            stopLoading({
                message: error.toString(),
                severity: "error",
            });

        };
    };

    const onCloseDlgFaseOne = () => {
        setOpenDlgViewFaseOne(false);
    };

    return (
        <>
            <DialogoAcompanhaOrcamentosFaseOne open={openDlgViewFaseOne} onClose={onCloseDlgFaseOne} orcamento={rowDataFaseOne} itens={dados} />
            <Typography variant='subtitle1' align='center'>
                Tomada de preço 1ª Fase
            </Typography>
            <MaterialTable
                columns={columns}
                data={loadOrcamentos}
                title={getTipoCarga(tipoCarga)}
                onRowClick={onRowClick}
                localization={materialTableLocalization}
                tableRef={tableRef} 
            />
        </>
    );
}
